import { type FC } from "react";

import { ActionModal } from "../../common/components/ActionModal";
import { confirmRemovalModalStyle } from "../../common/styles";
import { type ModalProps } from "../../core/hooks";

interface DeleteLensGroupModalProps extends ModalProps {
    groupIsDeleting: boolean;
    onDeleteLensGroup: () => Promise<unknown>;
}

export const DeleteLensGroupModal: FC<DeleteLensGroupModalProps> = ({
    groupIsDeleting,
    onDeleteLensGroup,
    ...modalProps
}) => (
    <ActionModal
        className={confirmRemovalModalStyle}
        title="Delete Lens Group"
        {...modalProps}
        onAction={onDeleteLensGroup}
        actionText={<span data-testid="delete-lens-group-confirm-dialog-remove-button">Delete</span>}
        isActionButtonPending={groupIsDeleting}
        isCancelButtonDisabled={groupIsDeleting}
    >
        <span>You’re about to delete lens group. Are you sure you want to delete it?</span>
    </ActionModal>
);
